export const Container = {
  baseStyle: {
    maxW: '1177px',
    px: 0,
  },
};
